import React from "react";

const VitrineMensuracao = () => {
  return (
    <section>
    
      <iframe src="https://app.powerbi.com/view?r=eyJrIjoiZjkyYmRhNTYtNDVlOS00MzI1LWEyOTEtZWY2YmQwZmJhMWQyIiwidCI6ImYyMzQ4MWYzLTI2ZGItNGZjOC1hNzliLTFiZTk2ZWZjMzg4YyIsImMiOjR9" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default VitrineMensuracao;
